export default class PetsInsured {
  /** (obligatorio, entero): Número de chip de la mascota. Ejemplo: 0123456789.  */
  chipNumber?: number | null

  /** (obligatorio, string): Nombre de la mascota. Ejemplo: "Rex".  */
  petName: string

  /** (obligatorio, fecha): Fecha de nacimiento de la mascota. Formato: "yyyy-MM-dd". Ejemplo: "2023-01-01".  */
  petBirthDate: string

  /** (obligatorio, entero): Código de tipo de mascota. Ejemplo: 01.  */
  petTypeCode: number

  /** (obligatorio, string): Código de raza de la mascota. Ejemplo: "62".  */
  breedCode: string

  /** (obligatorio, entero): Número de riesgo de la mascota. Ejemplo: 2.  */
  riskNumber: number

  /** (obligatorio, booleano): Indica si la mascota tiene seguro de accidentes. Ejemplo: true.  */
  hasAccidentInsurance?: boolean

  /** (opcional, string): Número de póliza de seguro de accidente. Ejemplo: 6124872.  */
  accidentPolicy?: string | null

  /** (opcional, string): Compañía de seguro de accidente. Ejemplo: "Mapfre".  */
  accidentCompany?: string | null

  /** (obligatorio, booleano): Indica si la mascota tiene seguro de responsabilidad civil. Ejemplo: true.  */
  hasRcInsurance?: boolean

  /** (opcional, string): Número de póliza de seguro de responsabilidad civil. Ejemplo: 6212457.  */
  rcPolicy?: string | null

  /** (opcional, string): Compañía de seguro de responsabilidad civil. Ejemplo: "Caser".  */
  rcCompany?: string | null

  constructor(data: any = {}) {
    this.chipNumber = data.chipNumber ? Number(data.chipNumber) : undefined
    this.petName = data.petName
    this.petBirthDate = data.petBirthDate
    this.petTypeCode = data.petTypeCode
    this.breedCode = data.breedCode
    this.riskNumber = data.riskNumber
    this.hasAccidentInsurance =
      typeof data.hasAccidentInsurance === 'boolean' ? data.hasAccidentInsurance : false
    this.accidentPolicy = data.accidentPolicy ? data.accidentPolicy : undefined
    this.accidentCompany = data.accidentCompany ? data.accidentCompany : undefined
    this.hasRcInsurance = typeof data.hasRcInsurance === 'boolean' ? data.hasRcInsurance : false
    this.rcPolicy = data.rcPolicy ? data.rcPolicy : undefined
    this.rcCompany = data.rcCompany ? data.rcCompany : undefined
  }
}
